/**
 * LEÓN BLANKS — Product Page Premium
 * Gallery, variants, cart, testimonials
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  class PremiumProductPage {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.variants = this.loadVariants();
      this.selectedOptions = this.getInitialOptions();
      this.galleryInterval = null;
      this.colorOptionIndex = this.getColorOptionIndex();
      this.init();
    }

    loadVariants() {
      var el = document.getElementById('LeonProductVariants-' + this.sectionId);
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return [];
      }
    }

    getInitialOptions() {
      var current = this.getCurrentVariant();
      if (!current) return [];
      return current.options.slice();
    }

    getColorOptionIndex() {
      var group = this.root.querySelector(
        '.variant-group[data-option-name="color"], .variant-group[data-option-name="colores"], .variant-group[data-option-name="colour"]'
      );
      return group ? parseInt(group.dataset.optionIndex, 10) : -1;
    }

    // --- MANEJO DEL TIEMPO DE LA GALERÍA ---
    startAutoGallery() {
      const self = this;
      const TIEMPO_CAMBIO_MS = 5000; // 5 segundos por foto

      if (this.galleryInterval) clearInterval(this.galleryInterval);

      this.galleryInterval = setInterval(function () {
        const visibleThumbs = Array.from(
          self.root.querySelectorAll('.premium-gallery__thumbnail')
        ).filter(function (thumb) {
          const wrapper = thumb.closest(
            '.premium-gallery__thumbnail-wrapper'
          );
          return wrapper && wrapper.style.display !== 'none';
        });

        if (visibleThumbs.length <= 1) return;

        let currentIndex = visibleThumbs.findIndex(function (thumb) {
          return thumb.classList.contains('active');
        });

        currentIndex =
          currentIndex === visibleThumbs.length - 1
            ? 0
            : currentIndex + 1;

        visibleThumbs[currentIndex].click();
      }, TIEMPO_CAMBIO_MS);
    }

    getCurrentVariant() {
      var input = this.root.querySelector('[data-variant-id]');
      if (!input) return this.variants[0];
      var id = parseInt(input.value, 10);
      return this.variants.find(function (v) { return v.id === id; }) || this.variants[0];
    }

    init() {
      this.initGallery();
      this.initVariants();
      this.initQuantity();
      this.initCart();
      this.initTestimonials();
      this.updateAvailability();
      
      this.updateVariant();
    }

    // --- EFECTO DE TRANSICIÓN MEJORADO (FADE PREMIUM) ---
    initGallery() {
      var mainImage = this.root.querySelector('#MainProductImage');
      var thumbs = this.root.querySelectorAll('.premium-gallery__thumbnail');
      if (!mainImage || !thumbs.length) return;

      mainImage.style.transition = 'opacity 0.25s ease-in-out, transform 0.2s ease';

      var self = this;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          self.startAutoGallery();

          if (thumb.classList.contains('active')) return;

          thumbs.forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          thumb.classList.add('active');
          thumb.setAttribute('aria-selected', 'true');

          var src = thumb.dataset.imageSrc;
          var alt = thumb.dataset.imageAlt || '';
          if (!src) return;

          mainImage.style.opacity = '0';
          
          setTimeout(function () {
            mainImage.src = src;
            mainImage.alt = alt;
            mainImage.style.opacity = '1';
          }, 200);
        });
      });

      this.initImageZoom(mainImage);
      this.startAutoGallery();
    }

    initImageZoom(image) {
      if (!image || window.matchMedia('(max-width: 749px)').matches) return;

      var zoomed = false;
      image.addEventListener('click', function () {
        zoomed = !zoomed;
        image.style.transform = zoomed ? 'scale(2)' : 'scale(1)';
        image.style.cursor = zoomed ? 'zoom-out' : 'crosshair';
      });

      image.addEventListener('mousemove', function (e) {
        if (!zoomed) return;
        var rect = image.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        image.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    initVariants() {
      var self = this;
      var options = this.root.querySelectorAll('.variant-option');

      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var position = parseInt(btn.dataset.optionPosition, 10) - 1;
          var value = btn.dataset.optionValue;

          var group = self.root.querySelectorAll(
            '.variant-option[data-option-position="' + btn.dataset.optionPosition + '"]'
          );
          group.forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');

          self.selectedOptions[position] = value;

          self.updateVariant();
        });
      });
    }

    // --- LOGICA DE ACTUALIZACIÓN SIN SALTOS DE PÁGINA ---
    updateVariant() {
      var variant = this.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === this.selectedOptions[i];
        }, this);
      }, this);

      // CORRECCIÓN: Actualizar URL de manera silenciosa sin mover el scroll del móvil
      if (variant) {
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== variant.id.toString()) {
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        }
      }
      if (!variant) return;

      var idInput = this.root.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      var priceEl = this.root.querySelector('[data-product-price]');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var addBtn = this.root.querySelector('[data-add-to-cart]');
      var buyBtn = this.root.querySelector('[data-buy-now]');
      var available = variant.available;

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Agregar al carrito' : 'Agotado';
      }
      if (buyBtn) buyBtn.disabled = !available;

      const colorLabel = this.root.querySelector(
        '#SelectedColor-' + this.sectionId
      );

      const selectedColorValue = this.colorOptionIndex >= 0 ? this.selectedOptions[this.colorOptionIndex] : '';

      if (colorLabel && selectedColorValue) {
        colorLabel.textContent = selectedColorValue;
      }

      this.updateAvailability();

      const selectedColor = (selectedColorValue || '').toLowerCase().trim();
      const thumbnails = this.root.querySelectorAll('.premium-gallery__thumbnail');
      var mainImage = this.root.querySelector('#MainProductImage');
      const colorMatchedThumbs = Array.from(thumbnails).filter(function (thumb) {
        const imageColor = (thumb.dataset.imageColor || '').toLowerCase().trim();
        return selectedColor && imageColor.includes(selectedColor);
      });

      thumbnails.forEach(function (thumb) {
        const imageColor = (thumb.dataset.imageColor || '').toLowerCase();
        const wrapper = thumb.closest('.premium-gallery__thumbnail-wrapper');
        const keepVisible =
          !selectedColor ||
          !colorMatchedThumbs.length ||
          imageColor.includes(selectedColor) ||
          imageColor.includes('talla');
        if (wrapper) wrapper.hidden = !keepVisible;
      });

      // Shopify's variant media association is the source of truth. Alt-text
      // matching remains as a safe fallback for older product data.
      const featuredMedia = variant.featured_media || variant.featured_image;
      const featuredMediaId = featuredMedia && featuredMedia.id ? String(featuredMedia.id) : '';
      const featuredThumb = featuredMediaId
        ? Array.from(thumbnails).find(function (thumb) { return thumb.dataset.mediaId === featuredMediaId; })
        : null;
      const fallbackThumb = colorMatchedThumbs[0] || Array.from(thumbnails).find(function (thumb) {
        const wrapper = thumb.closest('.premium-gallery__thumbnail-wrapper');
        return wrapper && !wrapper.hidden;
      });
      const targetThumb = featuredThumb || fallbackThumb;

      const variantImageSrc = featuredMedia && featuredMedia.src
        ? (function () {
            const imageUrl = new URL(featuredMedia.src, window.location.origin);
            imageUrl.searchParams.set('width', '1600');
            return imageUrl.toString();
          })()
        : '';

      if (targetThumb && mainImage) {
        thumbnails.forEach(function (thumb) {
          const isActive = thumb === targetThumb;
          thumb.classList.toggle('active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        const targetSrc = variantImageSrc || targetThumb.dataset.imageSrc;
        if (mainImage.src !== targetSrc) {
          mainImage.style.opacity = '0';
          setTimeout(function () {
            mainImage.src = targetSrc;
            mainImage.alt = targetThumb.dataset.imageAlt || '';
            mainImage.style.opacity = '1';
          }, 160);
        }
      } else if (mainImage && variantImageSrc && mainImage.src !== variantImageSrc) {
        mainImage.style.opacity = '0';
        setTimeout(function () {
          mainImage.src = variantImageSrc;
          mainImage.style.opacity = '1';
        }, 160);
      }
    }

    updateAvailability() {
      const self = this;

      this.root.querySelectorAll('.variant-option').forEach(function(btn) {
        const position = parseInt(btn.dataset.optionPosition, 10) - 1;
        const value = btn.dataset.optionValue;

        const options = [...self.selectedOptions];
        options[position] = value;

        const matchingVariant = self.variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return opt === options[i];
          });
        });

        if (!matchingVariant || !matchingVariant.available) {
          btn.classList.add('is-sold-out');
        } else {
          btn.classList.remove('is-sold-out');
        }
      });
    }

    initQuantity() {
      var minus = this.root.querySelector('.qty-btn--minus');
      var plus = this.root.querySelector('.qty-btn--plus');
      var input = this.root.querySelector('.qty-input');
      if (!minus || !plus || !input) return;

      minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });

      plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) input.value = 1;
      });
    }

    initCart() {
      var self = this;
      var addBtn = this.root.querySelector('[data-add-to-cart]');
      var buyBtn = this.root.querySelector('[data-buy-now]');

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          self.addToCart(false);
        });
      }
      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          self.addToCart(true);
        });
      }
    }

    addToCart(checkout) {
      var form = this.root.querySelector('.premium-product-form');
      if (!form || !window.LeonCart) return;

      var variantId = form.querySelector('[data-variant-id]').value;
      var quantity = parseInt(form.querySelector('.qty-input').value, 10) || 1;
      var addBtn = this.root.querySelector('[data-add-to-cart]');
      var buyBtn = this.root.querySelector('[data-buy-now]');

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.dataset.lbOriginalText = addBtn.textContent;
        addBtn.textContent = 'Agregando…';
      }

      var productImage = this.root.querySelector('.premium-gallery__main img');

      window.LeonCart.add(variantId, quantity, { image: productImage, source: addBtn })
        .then(function () {
          if (checkout) {
            window.location.href = '/checkout';
          } else if (addBtn) {
            addBtn.classList.add('is-added');
            addBtn.textContent = '✓ Agregado al carrito';
          }
        })
        .catch(function (err) {
          this.notify(err.message || 'No se pudo agregar al carrito', 'error');
        }.bind(this))
        .finally(function () {
          if (addBtn) setTimeout(function () {
            addBtn.disabled = false;
            addBtn.classList.remove('is-added');
            addBtn.textContent = addBtn.dataset.lbOriginalText || 'Agregar al carrito';
          }, checkout ? 0 : 900);
          if (buyBtn) buyBtn.disabled = false;
        });
    }

    notify(message, type) {
      var el = document.createElement('div');
      el.className = 'lb-notification' + (type === 'error' ? ' lb-notification--error' : '');
      el.textContent = message;
      document.body.appendChild(el);
      setTimeout(function () {
        el.remove();
      }, 3200);
    }

    initTestimonials() {
      var slider = this.root.querySelector('[data-testimonials-slider]');
      if (!slider) return;

      var slides = slider.querySelectorAll('[data-testimonial-slide]');
      var prev = this.root.querySelector('[data-testimonials-prev]');
      var next = this.root.querySelector('[data-testimonials-next]');
      var dotsWrap = this.root.querySelector('[data-testimonials-dots]');
      var current = 0;

      if (slides.length <= 1) return;

      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'testimonials-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Testimonio ' + (i + 1));
          dot.addEventListener('click', function () {
            show(i);
          });
          dotsWrap.appendChild(dot);
        });
      }

      function show(index) {
        current = index;
        slides.forEach(function (slide, i) {
          if (i === index) {
            slide.removeAttribute('hidden');
            slide.classList.add('is-active');
          } else {
            slide.setAttribute('hidden', '');
            slide.classList.remove('is-active');
          }
        });
        if (dotsWrap) {
          dotsWrap.querySelectorAll('.testimonials-dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
          });
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show((current - 1 + slides.length) % slides.length);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show((current + 1) % slides.length);
        });
      }

      setInterval(function () {
        show((current + 1) % slides.length);
      }, 7000);
    }
  }

  function boot() {
    document.querySelectorAll('.premium-product-page').forEach(function (root) {
      new PremiumProductPage(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  
})();
